import React from 'react';
import Select from 'react-select';

const MultiSelect = ({ options, value, onChange, label, placeholder, isMulti = true, error }) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#374151',
      borderColor: error ? '#EF4444' : '#4B5563',
      color: '#F9FAFB',
      boxShadow: state.isFocused ? '0 0 0 1px #EF4444' : null,
      '&:hover': {
        borderColor: error ? '#EF4444' : '#4B5563',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#374151',
      borderColor: '#4B5563',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#EF4444'
        : state.isFocused
        ? '#4B5563'
        : '#374151',
      color: '#F9FAFB',
      '&:active': {
        backgroundColor: '#EF4443',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#EF4444',
      color: '#F9FAFB',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#F9FAFB',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#F9FAFB',
      '&:hover': {
        backgroundColor: '#DC2626',
        color: '#F9FAFB',
      },
    }),
    input: (provided) => ({
      ...provided,
      color: '#F9FAFB',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#F9FAFB',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#D1D5DB',
    }),
  };

  return (
    <div className="mb-4">
      <label className="block text-text-gray text-sm font-bold mb-2">
        {label}
      </label>
      <Select
        isMulti={isMulti}
        name="multi-select"
        options={options}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        styles={customStyles}
        theme={(theme) => ({
          ...theme,
          borderRadius: 5,
          colors: {
            ...theme.colors,
            primary25: '#4B5563',
            primary: '#EF4444',
            neutral0: '#374151',
            neutral80: '#F9FAFB',
            neutral20: error ? '#EF4444' : '#4B5563',
            neutral30: error ? '#EF4444' : '#4B5563',
          },
        })}
      />
    </div>
  );
};

export default MultiSelect;